import { useEffect, useState } from "react";

export default function Sitemap() {
  const [sitemapXml, setSitemapXml] = useState("");

  useEffect(() => {
    const fetchSitemap = async () => {
      try {
        const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
        const response = await fetch(`${BACKEND_URL}/api/sitemap.xml`);
        const xml = await response.text();
        setSitemapXml(xml);
      } catch (error) {
        console.error("Failed to fetch sitemap:", error);
      }
    };
    fetchSitemap();
  }, []);

  return (
    <div style={{ fontFamily: 'monospace', whiteSpace: 'pre-wrap', padding: '20px' }}>
      {sitemapXml}
    </div>
  );
}
